import { simplrOrderGetQuery, simplrOrderPostQuery } from '../../../api/orders/simplrOrder';
import { setLoadingUnique } from '../../index';
import { addEdgeToDecisionTreePath } from '../../searchActions';
import { showErrorMessage } from '../../../util/errorPopupUtil';
import { trackDecisionTreeSubscriptionSearch } from '../../../analytics/searchEventAnalytics';
import { displayPopupMessageInformation } from '../../../components/tools/SearchPage/searchUtils';
import { extractSelectedTicketIdFromState, getSimplrAccountIdOfSelectedTicket } from '../../../extractFromState';
import { setSubscriptions } from '../CommonSubscriptionActions';

export const assignToCustomerGroup = (simplrAccountPtrId, query) => async (dispatch, getState) => {
  try {
    const conversationId = extractSelectedTicketIdFromState(getState());
    const combinedQuery = Object.assign({}, query, {
      simplrAccountId: simplrAccountPtrId,
      conversationId,
    });

    const response = await simplrOrderPostQuery('/assignToCustomerGroup', combinedQuery);

    if (response) {
      if (response.success) {
        dispatch(addEdgeToDecisionTreePath('brand_assigned_successfully'));
      } else if (response.errorMessage && response.errorMessage.includes('already a member')) {
        dispatch(addEdgeToDecisionTreePath('customer_already_assigned'));
      } else {
        showErrorMessage(response.errorMessage || 'There was a problem assigning the group');
      }
    }
  } catch (e) {
    if (e.message.includes('Customer not found.')) {
      return dispatch(addEdgeToDecisionTreePath('wrong_email'));
    }
  }
};

export const searchSubscriptionsViaSimplrOrder = (searchType, searchValue) => async (dispatch, getState) => {
  const simplrAccountId = getSimplrAccountIdOfSelectedTicket(getState());
  const subscriptionSearchParams = {
    simplrAccountPtrId: simplrAccountId,
    searchQuery: searchValue,
    searchType,
  };

  try {
    dispatch(setLoadingUnique(true, 'searchPage'));
    trackDecisionTreeSubscriptionSearch(subscriptionSearchParams);
    const subscriptions = await simplrOrderGetQuery('/subscriptions', subscriptionSearchParams);
    dispatch(setSubscriptions(subscriptions));
  } catch (error) {
    const errorMessage = error?.response?.text || 'Search failed';
    displayPopupMessageInformation(errorMessage);
  } finally {
    dispatch(setLoadingUnique(false, 'searchPage'));
  }
};
